"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageTemplateResponseSchema = exports.MessageTemplateResultSchema = exports.MessageTemplateListResponseSchema = exports.MessageTemplateListResultSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
const MessageTemplateListItemSchema = schemas_1.MessageTemplateSchema.pick({
    id: true,
    name: true,
    updatedAt: true,
});
exports.MessageTemplateListResultSchema = zod_1.z
    .object({ templates: MessageTemplateListItemSchema.array() })
    .extend(schemas_1.PaginationResponseSchema.shape);
exports.MessageTemplateListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.MessageTemplateListResultSchema);
exports.MessageTemplateResultSchema = zod_1.z.object({ template: schemas_1.MessageTemplateSchema });
exports.MessageTemplateResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.MessageTemplateResultSchema);
